<template>
  <div class="hetongbao">
    <insuranceSelect :showclose="true" />
    <div class="bottom" :class="{ bottom1: grade == 3 }">
      <el-button class="bottom_1" @click="sub" type="primary" plain>提交</el-button>
      <!-- <div class="bottom_2" @click="fangqi">放弃保障</div> -->
      <div class="bottom_3" v-if="title">
        已选择：
        <span>{{ title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import insuranceSelect from "@/components/insuranceSelect";
export default {
  components: {
    insuranceSelect,
  },
  data() {
    return {};
  },

  computed: {
    ...mapState("insuranceSelect", ["insuranceId", "title", "insuranceVersion", "grade"]),
    ...mapState("hetongqianshu", ["step"]),
  },
  mounted() {},
  methods: {
    ...mapActions("hetongqianshu", ["setStep"]),
    sub() {
      if (this.insuranceId === null) {
        this.$alert("请选择合同保障方案，或勾选“放弃保障”", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      //   this.$emit('submit')
      this.setStep(this.step+1)
    },
  },
};
</script>

<style lang="scss" scoped>
.hetongbao {
  .bottom {
    display: flex;
    align-items: center;
    padding: 0 16px;
    height: 50px;
    margin: 10px 0;
    &_1 {
      @include buttonStyle;
      cursor: pointer;
    }

    &_2 {
      color: #999;
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 0 40px;
    }

    &_3 {
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: #666;
      margin: 0 40px;
    }
  }
  .bottom1{
    .bottom_1{
      background: linear-gradient(270deg, #FEDF92 0%, #FEECC4 100%);
      color: #3E3E64;
      border-color: transparent;
    }
    .bottom_3{
      color: #fff;
      span{
        color: #FEDF94;
      }
    }
  }
}
</style>
